import { render } from "./Profiles.vue?vue&type=template&id=26a1263a&scoped=true"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"

import "./Profiles.vue?vue&type=style&index=0&id=26a1263a&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a1263a"]])

export default __exports__